module.exports = __webpack_public_path__ + "static/media/ipad.b90aa39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/remoteretro/ipad.png
// module id = 90
// module chunks = 0